import { mediaQuery } from '~/js/helpers';

let headerHeight = document.querySelector('#site-header') ? document.querySelector('#site-header').offsetHeight : 80;
let prevScrollPos = window.scrollY;

// Admin bar offset
if (document.querySelector('#wpadminbar')) {
	headerHeight += document.querySelector('#wpadminbar').offsetHeight;
}

window.addEventListener('scroll', function () {
	if (!mediaQuery('lg-up')) {
		return;
	}

	const stickyHeader = document.querySelector('[data-sticky-nav]');

	if (!stickyHeader) {
		return;
	}

	if (window.scrollY > headerHeight) {
		stickyHeader.classList.add('is-sticky');
	} else {
		stickyHeader.classList.remove('is-sticky');
	}

	const currentScrollPos = window.scrollY;

	if (prevScrollPos > currentScrollPos) {
		// user has scrolled up
		stickyHeader.classList.add('show');
	} else if (window.scrollY > headerHeight) {
		// user has scrolled down
		stickyHeader.classList.remove('show');
	}

	prevScrollPos = currentScrollPos;
});
